import React from "react";
import styles from "../DressingChangeFrequency.module.scss";
import { UNIT_OPTIONS, clampInt } from "../utils/scheduleUtils";
import type { Schedule, SchedulePatch, ScheduleUnit } from "../types";

interface EveryPanelProps {
  schedule: Schedule;
  onChange: (patch: SchedulePatch) => void;
}

export const EveryPanel: React.FC<EveryPanelProps> = ({ schedule, onChange }) => (
  <div className={styles.panel}>
    <span className={styles.panel_inline_label}>Every</span>
    <div className={styles.stepper}>
      <button
        type="button"
        aria-label="Decrease"
        className={styles.stepper_btn}
        onClick={() => onChange({ every: Math.max(1, schedule.every - 1) })}
      >
        {"\u2212"}
      </button>
      <input
        type="number"
        min="1"
        max="99"
        aria-label="Interval"
        className={styles.stepper_input}
        value={schedule.every}
        onChange={(e) => onChange({ every: clampInt(e.target.value, 1, 99) })}
      />
      <button
        type="button"
        aria-label="Increase"
        className={styles.stepper_btn}
        onClick={() => onChange({ every: Math.min(99, schedule.every + 1) })}
      >
        +
      </button>
    </div>
    <div role="group" aria-label="Unit" className={styles.chip_group}>
      {UNIT_OPTIONS.map((u) => {
        const on = schedule.unit === u;
        return (
          <button
            key={u}
            type="button"
            className={`${styles.chip} ${on ? styles.chip_on : ""}`}
            aria-pressed={on}
            onClick={() => onChange({ unit: u as ScheduleUnit })}
          >
            {u.charAt(0).toUpperCase() + u.slice(1)}
          </button>
        );
      })}
    </div>
  </div>
);
